import { useState, useRef, useEffect } from 'react';
import '../styles/ExportVote.css';
import '../styles/BaseForm.css';
import '../styles/WaitingRoom.css';

import fr from '../locales/fr';
import en from '../locales/en';

import { useNavigate, useLocation, Navigate } from 'react-router-dom';

import normalImage1 from '../img/prop1.png';
import normalImage2 from '../img/prop2.png';
import normalImage3 from '../img/prop3.png';
import normalImage4 from '../img/prop4.png';
import normalImage5 from '../img/prop5.png';
import normalImage6 from '../img/prop6.png';
import normalImage7 from '../img/prop7.png';
import normalImage8 from '../img/prop8.png';
import normalImage9 from '../img/prop9.png';
import normalImage10 from '../img/prop10.png';
import normalImage11 from '../img/prop11.png';
import normalImage12 from '../img/prop12.png';
import normalImage13 from '../img/prop13.png';
import normalImage14 from '../img/prop14.png';
import normalImage15 from '../img/prop15.png';
import normalImage16 from '../img/prop16.png';
import normalImage17 from '../img/prop17.png';
import normalImage18 from '../img/prop18.png';
import spookyImage1 from '../img_spooky/halloween_prop1.png';
import spookyImage2 from '../img_spooky/halloween_prop2.png';
import spookyImage3 from '../img_spooky/halloween_prop3.png';
import spookyImage4 from '../img_spooky/halloween_prop4.png';
import spookyImage5 from '../img_spooky/halloween_prop5.png';
import spookyImage6 from '../img_spooky/halloween_prop6.png';
import spookyImage7 from '../img_spooky/halloween_prop7.png';
import spookyImage8 from '../img_spooky/halloween_prop8.png';
import spookyImage9 from '../img_spooky/halloween_prop9.png';
import spookyImage10 from '../img_spooky/halloween_prop10.png';
import spookyImage11 from '../img_spooky/halloween_prop11.png';
import spookyImage12 from '../img_spooky/halloween_prop12.png';
import spookyImage13 from '../img_spooky/halloween_prop13.png';
import spookyImage14 from '../img_spooky/halloween_prop14.png';
import spookyImage15 from '../img_spooky/halloween_prop15.png';

const isHalloween = new Date().getMonth() === 9;

const getCookie = (name) => {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
};

const setCookie = (name, value, minutes = 120) => {
    const expires = new Date(Date.now() + minutes * 60000).toUTCString();
    document.cookie = `${name}=${value};expires=${expires};path=/`;
};

const deleteCookie = (name) => {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
};

function Ready({ ws }) {
    const navigate = useNavigate();
    const location = useLocation();

    const browserLang = navigator.language || navigator.userLanguage;
    const language = browserLang.startsWith('fr') ? 'fr' : 'en';
    const translations = language === 'fr' ? fr : en;

    const allowed =
        location.state?.fromAuthorized ||
        sessionStorage.getItem('canAccessReady');

    const savedRole = getCookie('playerRole');

    const [role, setRole] = useState(savedRole || null);
    const [countdown, setCountdown] = useState(null);

    const intervalRef = useRef(null);
    const roleRef = useRef(savedRole || null);
    const rdySentRef = useRef(false);
    const countdownActiveRef = useRef(false);

    // --------------------------------------------------
    // Autorisation d'accès à Ready
    // --------------------------------------------------

    useEffect(() => {
        if (allowed) {
            sessionStorage.removeItem('canAccessReady');
        }
    }, [allowed]);

    // --------------------------------------------------
    // Messages WebSocket
    // --------------------------------------------------

    useEffect(() => {
        if (!ws) return;

        const handleWebSocketMessage = (event) => {
            const msg = event.data;
            const ROOM = localStorage.getItem('UNITY');

            if (!ROOM) return;

            // ------------------------------------------
            // La partie retourne en attente
            // ------------------------------------------

            if (msg === ROOM + ':WAIT') {
                // Annuler un éventuel compte à rebours
                if (intervalRef.current) {
                    clearInterval(intervalRef.current);
                    intervalRef.current = null;
                }

                setCountdown(null);

                // Le joueur n'est plus dans l'état GO
                roleRef.current = 'waiting';

                setCookie('playerRole', 'waiting');
                setRole('waiting');

            // ------------------------------------------
            // Un joueur est désigné comme STARTER
            // ------------------------------------------

            } else if (msg === ROOM + ':STARTER') {

                // Annuler un éventuel compte à rebours
                if (intervalRef.current) {
                    clearInterval(intervalRef.current);
                    intervalRef.current = null;
                }

                setCountdown(null);

                roleRef.current = 'starter';

                setCookie('playerRole', 'starter');
                setRole('starter');

            // ------------------------------------------
            // La partie peut continuer
            // ------------------------------------------

            } else if (msg === ROOM + ':GO') {

                // IMPORTANT :
                // On accepte GO uniquement si ce joueur
                // était auparavant STARTER.
                if (roleRef.current === 'starter') {
                    setCookie('playerRole', 'go');
                    roleRef.current = 'go';
                    setRole('go');
                    ws.send(ROOM + ':STARTER OK');
                }

            } else if (msg === ROOM + ':Salle Pleine') {

                if (intervalRef.current) {
                    clearInterval(intervalRef.current);
                    intervalRef.current = null;
                }

                deleteCookie('playerRole');
                navigate('/');
            }
        };

        // --------------------------------------------------
        // Animation
        // --------------------------------------------------

        const handleTransitionEnd = (event) => {
            const container = document.querySelector('.container');
            const image = event.target;

            if (container && container.contains(image)) {
                container.removeChild(image);
            }
        };

        const generateImages = () => {
            const numberOfImages = 5;
            const container = document.querySelector('.container');

            if (!container) return;

            const images = isHalloween
                ? [spookyImage1, spookyImage2, spookyImage3, spookyImage4, spookyImage5,
                   spookyImage6, spookyImage7, spookyImage8, spookyImage9, spookyImage10,
                   spookyImage11, spookyImage12, spookyImage13, spookyImage14, spookyImage15]
                : [normalImage1, normalImage2, normalImage3, normalImage4, normalImage5,
                   normalImage6, normalImage7, normalImage8, normalImage9, normalImage10,
                   normalImage11, normalImage12, normalImage13, normalImage14, normalImage15,
                   normalImage16, normalImage17, normalImage18];

            for (let i = 0; i < numberOfImages; i++) {
                const image = document.createElement('img');

                const randomImageIndex = Math.floor(
                    Math.random() * images.length
                );

                const randomSize = Math.random() * 50 + 30;

                const randomX =
                    Math.random() *
                    (window.innerWidth - randomSize);

                const randomAnimationDuration =
                    Math.random() * 5 + 2;

                image.setAttribute(
                    'src',
                    images[randomImageIndex]
                );

                image.classList.add('rain-image');

                image.style.width = `${randomSize}px`;
                image.style.position = 'absolute';
                image.style.left = `${randomX}px`;
                image.style.top = `-${randomSize}px`;
                image.style.animationDuration =
                    `${randomAnimationDuration}s`;

                image.style.transition =
                    `top ${randomAnimationDuration}s linear`;

                container.appendChild(image);

                setTimeout(() => {
                    image.style.top =
                        `${window.innerHeight}px`;
                }, 0);
            }
        };

        const container = document.querySelector('.container');

        if (container) {
            container.addEventListener(
                'transitionend',
                handleTransitionEnd
            );
        }

        ws.addEventListener(
            'message',
            handleWebSocketMessage
        );

        generateImages();

        const interval = setInterval(
            generateImages,
            2500
        );

        return () => {
            clearInterval(interval);

            if (intervalRef.current) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }

            if (container) {
                container.removeEventListener(
                    'transitionend',
                    handleTransitionEnd
                );
            }

            ws.removeEventListener(
                'message',
                handleWebSocketMessage
            );
        };
    }, [ws]);

    // --------------------------------------------------
    // Démarrer la partie
    // --------------------------------------------------

    const handleStart = () => {
        // Évite de créer plusieurs intervals
        if (intervalRef.current) return;

        countdownActiveRef.current = true;
        setCountdown(5);

        let remaining = 5;

        intervalRef.current = setInterval(() => {
            remaining -= 1;

            // ------------------------------------------
            // Compte terminé
            // ------------------------------------------

            if (remaining <= 0) {
                clearInterval(intervalRef.current);

                intervalRef.current = null;
                countdownActiveRef.current = false;

                setCountdown(null);

                const ROOM =
                    localStorage.getItem('UNITY');

                // Vérification de sécurité
                if (!ROOM || !ws) {
                    return;
                }

                // Envoie RDY au serveur
                rdySentRef.current = true;
                ws.send(ROOM + ':RDY');

                deleteCookie('playerRole');

                sessionStorage.setItem(
                    'canAccessWaitingState',
                    'true'
                );

                navigate('/waitingState', {
                    state: {
                        fromAuthorized: true
                    }
                });

            } else {
                setCountdown(remaining);
            }

        }, 1000);
    };

    // --------------------------------------------------
    // Annuler le démarrage
    // --------------------------------------------------

    const handleCancel = () => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }

        countdownActiveRef.current = false;
        setCountdown(null);
    };

    // --------------------------------------------------
    // Accès non autorisé
    // --------------------------------------------------

    if (!allowed) {
        return <Navigate to="/" replace />;
    }

    const isCounting = countdown !== null;

    // --------------------------------------------------
    // Joueur en attente
    // --------------------------------------------------

    if (role === 'waiting') {
        deleteCookie('playerRole');

        sessionStorage.setItem(
            'canAccessWaitingState',
            'true'
        );

        return (
            <Navigate
                to="/waitingState"
                state={{ fromAuthorized: true }}
                replace
            />
        );
    }

    // --------------------------------------------------
    // Joueur STARTER
    // --------------------------------------------------

    if (role === 'starter') {
        return (
            <div className="container">
                <h1 className="title">
                    {translations.waitingState.title}
                    <span className="dots"></span>
                </h1>

                <div className="loader"></div>
            </div>
        );
    }

    // --------------------------------------------------
    // Joueur GO
    // --------------------------------------------------

    if (role === 'go') {
        return (
            <div className="boxform">
                <h1 className="title">
                    {translations.ready.title}
                </h1>

                <button
                    className="submit-button"
                    onClick={
                        isCounting
                            ? handleCancel
                            : handleStart
                    }
                    style={
                        isCounting
                            ? {
                                  background:
                                      'linear-gradient(135deg, #ff4444 0%, #cc0000 100%)'
                              }
                            : undefined
                    }
                >
                    {isCounting
                        ? `${translations.ready.cancel} (${countdown})`
                        : translations.ready.button}
                </button>
            </div>
        );
    }

    // --------------------------------------------------
    // Aucun rôle
    // --------------------------------------------------

    return <div className="boxform" />;
}

export default Ready;